export default __webpack_public_path__ + "static/media/8.e0048e41.jpg";